interface ImageItemTypes {
  url: string;
  name: string;
  status: number;
}
interface ColorTypes {
  commonColor: string;
  rightPhotoColor: string;
  wrongPhotoColor: string;
  mainColor?: string;
  textColor?: string;
}

export interface NfcBridgeType {
  status: 'success' | 'fail';
  isNFCAvailable?: IS_NFC_AVAILABLE;
  errorCode?: number;
  errorMsg?: string;
}

export const ID_CARD_IMAGE: string[] = [
  'https://p0.meituan.net/scarlett/932bc3fab7d29e22c276879256d85e9753328.png',
  'https://p0.meituan.net/scarlett/0f5f7d6671cd77af534624bfdf805f4159593.png'
];

// 示例部分展示配置
export const EXMPLE_IMAGE: ImageItemTypes[] = [
  {
    url:
      'https://p0.meituan.net/scarlett/0715507842b1d1266179746d6e82606618286.png',
    name: '标准',
    status: 0 // 0 表示正确
  },
  {
    url:
      'https://p1.meituan.net/scarlett/927ffb5902428ae58ffd0b477f5cdf1813761.png',
    name: '边框缺失',
    status: 1 // 1 错误
  },
  {
    url:
      'https://p1.meituan.net/scarlett/940f85dfb49c440c36f828790132209a7859.png',
    name: '照片模糊',
    status: 1
  },
  {
    url:
      'https://p0.meituan.net/scarlett/350e752d1677aba7216ddef97e7a096d9536.png',
    name: '闪光强烈',
    status: 1
  }
];

// 基础颜色配置
export const DEFAULT_COLOR: ColorTypes = {
  commonColor: '#FE8C00',
  rightPhotoColor: '#FE8C00',
  wrongPhotoColor: '#F06A5B',
  mainColor: '', // 主色调黄，按钮为渐变色，姓名和选中颜色不一致，此处不设置默认色。但是定制时，三个位置颜色一致。
  textColor: '#222222'
};

// page type 0 上传身份证 1 手持身份证拍摄
export enum PAGE_TYPE {
  ID_CARD,
  HAND_CARD
}

// 验证桥process 1 进行身份证正反面拍照并上传, 2 调起相册, 3 进行手持身份证拍照并上传, 4 cnacel
export enum PROCESS_TYPE {
  PHOTO = 1,
  ALBUM,
  HAND,
  CANCEL,
  API_ERROR,
  NOTIFY_FINISH_IOS
}

export enum IS_NFC_AVAILABLE {
  NOT_SUPPORT = 0,
  SUPPORT_NOT_OPEN,
  OPENED
}

export const ERRORLEVELTYPES = {
  showToast: 1,
  showModal: 2
};
